(function () {
  function initJojoListingVideo(root) {
    if (!root || root.dataset.jojoVideoReady === 'true') return;
    root.dataset.jojoVideoReady = 'true';

    var hit = root.querySelector('[data-jojo-video-open]');
    var modal = root.querySelector('[data-jojo-video-modal]');
    var player = modal ? modal.querySelector('.jojo-listing-video__player') : null;
    var youtubeId = player ? player.getAttribute('data-youtube-id') : '';
    var lastFocus = null;
    var isOpen = false;

    function stageVideos() {
      return root.querySelectorAll('.jojo-listing-video__clip');
    }

    function visibleStageVideo() {
      var videos = stageVideos();
      for (var i = 0; i < videos.length; i++) {
        if (window.getComputedStyle(videos[i]).display !== 'none') return videos[i];
      }
      return videos[0] || null;
    }

    function playStage() {
      var active = visibleStageVideo();
      stageVideos().forEach(function (video) {
        video.muted = true;
        if (video !== active) {
          try {
            video.pause();
          } catch (e) {}
          return;
        }
        var playPromise = video.play();
        var reveal = function () {
          root.classList.add('is-playing');
        };
        if (playPromise && typeof playPromise.then === 'function') {
          playPromise.then(reveal).catch(function () {});
        } else {
          reveal();
        }
      });
    }

    function pauseStage() {
      stageVideos().forEach(function (video) {
        try {
          video.pause();
        } catch (e) {}
      });
    }

    function lockScroll(lock) {
      document.documentElement.classList.toggle('jojo-video-modal-open', lock);
    }

    function closeModal() {
      if (!modal || !isOpen) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      isOpen = false;
      if (player) player.removeAttribute('src');
      lockScroll(false);
      playStage();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    function openModal(trigger) {
      if (!modal || !player || !youtubeId || isOpen) return;
      lastFocus = trigger || document.activeElement;
      player.src = 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      isOpen = true;
      pauseStage();
      lockScroll(true);
      var closeBtn = modal.querySelector('.jojo-listing-video__close');
      if (closeBtn) closeBtn.focus();
    }

    stageVideos().forEach(function (video) {
      video.addEventListener('playing', function () {
        if (video === visibleStageVideo()) root.classList.add('is-playing');
      });
    });

    if (hit) {
      hit.addEventListener('click', function (event) {
        event.preventDefault();
        openModal(hit);
      });
    }

    root.addEventListener('click', function (event) {
      var closeEl = event.target.closest('[data-jojo-video-close]');
      if (closeEl && root.contains(closeEl)) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeModal();
    });

    var desktopQuery = window.matchMedia('(min-width: 750px)');
    var onBreakpoint = function () {
      if (!isOpen) playStage();
    };
    if (typeof desktopQuery.addEventListener === 'function') {
      desktopQuery.addEventListener('change', onBreakpoint);
    } else if (typeof desktopQuery.addListener === 'function') {
      desktopQuery.addListener(onBreakpoint);
    }

    playStage();

    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(root)) return;
      closeModal();
      pauseStage();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-jojo-listing-video]').forEach(initJojoListingVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-jojo-listing-video]');
    if (root) {
      root.dataset.jojoVideoReady = 'false';
      initJojoListingVideo(root);
    }
  });
})();
